import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { getAntifraudeImage } from 'services/apiKYP'
import PropTypes from "prop-types"
import LoadingComponent from "../../../LoadingComponent"

const ImageLoader = ({ item }) => {
  const [imgSrc, setImgSrc] = useState(null)
  const [downloadError, setDownloadError] = useState(null)

  const token = useSelector((state) => state.auth.access_token)

  useEffect(() => {
    getAntifraudeImage(token, item?.optimizedImageName || item?.originalImageName)
      .then((response) => {
        const url = URL.createObjectURL(response.data)
        setImgSrc(url)
        setDownloadError(null)
      })
      .catch((error) => {
        console.error(error)
        setDownloadError("Falha ao carregar imagem")
        setImgSrc(null)
      })
  }, [item])

  if (!imgSrc) {
    return (
      downloadError ? <p>{downloadError}</p> :
        <LoadingComponent
          loadingText='Carregando imagem...'
          layoutOrientation="vertical"
          textColor='#FFF'
          progressSize={36}
          textSize='20px'
          progressColor="#FFF"
        />
    )
  }

  return <img src={imgSrc} alt={item?.alt} />
}

ImageLoader.propTypes = {
  item: PropTypes.shape(
    {
      optimizedImageName: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      alt: PropTypes.string,
      originalImageName: PropTypes.string.isRequired,
    },
  ).isRequired,
}

export default ImageLoader
